<template>
  <div class="google-login-page" v-loading="loading">
    <div class="google-header">
      <img src="../../assets/img/glogin-logo.png" alt="ASOGROW Logo" class="logo-img" />
      <div class="langBtn" @click="changeLang">EN/CN</div>
    </div>
    <div class="google-content">
      <el-form
          :model="login"
          :rules="rules"
          ref="loginForm"
          class="login-form"
        >
        <div class="login-title">
          <div>{{$t('messages.gLogin.loginText')}}</div>
        </div>
        <el-form-item prop="contact_number" class="application-number">
          <label class="form-label">{{$t('messages.gLogin.contact')}}</label>
          <el-input v-model="login.contact_number"  class="login-input2">
            <el-select
              v-model="login.contact_type"
              slot="prepend"
              :placeholder="$t('messages.myCampaign.list11')"
              popper-class="app-select"
              @change="changeContactType"
              ref="contact_type"
            >
              <el-option
                v-for="item in applications"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <img
                  :src="item.src"
                  style="width: 16px;height: 16px;margin-right: 16px;vertical-align: -3px;"
                />
                <span>{{ item.label }}</span>
              </el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <div class="contact-tip-wrap">
          <img src="../../assets/img/icon-tip2.png" class="tip-wrap-logo" />
          <p>{{$t('messages.gLogin.contactTip')}}</p>
        </div>
        <el-form-item prop="product_url">
          <label class="form-label">{{$t('messages.gLogin.link')}}</label>
          <el-input
            class="login-input"
            autocomplete="off"
            v-model="login.product_url"
            name="password"
            :placeholder="$t('messages.gLogin.linkInput')"
            @change="changeAppStoreUrl"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="login-btn" @click="Login">{{$t('messages.gLogin.loginBtn')}}</div>
        </el-form-item>
        <p class="jump-tip">
          <span @click="Login('jump')">{{$t('messages.gLogin.jump')}}</span>
        </p>
      </el-form>
    </div>
    <div class="guide-contact" v-if="showContactVisible">
      <div>
        <img src="../../assets/img/guide-contact.png" class="tip-wrap-logo" />
        <p>{{$t('messages.gLogin.warnTitle')}}</p>
      </div>
      <p>{{$t('messages.gLogin.warnContent')}}</p>
    </div>
    <!-- <contact-box @callback="showContact"></contact-box> -->
  </div>
</template>

<script>
  // import { setCookie } from 'tiny-cookie'
  import loginAndRegisterMixin from '@/mixins/loginAndRegisterMixin'
  export default {
    mixins:[ loginAndRegisterMixin ],
    data(){
      return {
        showContactVisible:true,
        loading:false,
        rules:{},
        login:{
          contact_number:'',
          product_url:'',
          contact_type:3,
        },
        token:'',
        register_source:'',
        applications: [
          { label: 'WhatsApp', value: 3, src: require('../../assets/img/WhatsApp.png') },
          { label: 'Teams', value: 1, src: require('../../assets/img/Teams.png') },
          { label: 'Telegram', value: 5, src: require('../../assets/img/Telegram.png') },
          { label: 'WeChat', value: 7, src: require('../../assets/img/WeChat.png') },
          { label: 'Phone', value: 8, src: require('../../assets/img/Phone-b.png') },
        ],
      }
    },
    watch:{
      $route: {
        handler: function(val, oldVal) {
          let s = val.query.s
          if (s === undefined) {
            // 自动处理url
            window.location.href = val.fullPath + '&s=Official'
            this.register_source = 'Official'
          } else {
            this.register_source = s
          }
        },
        // 深度观察监听
        immediate: true,
      },
      '$i18n.locale': function () {
        this.setFormRules()
        this.$nextTick(() => {
          if(this.$refs['loginForm']){
            this.$refs['loginForm'].fields.forEach(item => {
              item.clearValidate()
            })
          }
        })
      },
    },
    created(){
      this.token = this.$route.query.token;
      this.login.product_url = this.$route.query.pl || ''
      this.setFormRules()
      this.$nextTick(()=>{
        this.changeContactType(this.login.contact_type)
      })
    },
    methods: {
      showContact(flag){
        this.showContactVisible = !flag
      },
      setFormRules(){
        this.rules={
          contact_number: [
            { required: true, message: this.$t('messages.gLogin.contactErr'), trigger: ['blur', 'change'] },
          ],
          product_url: [
            { required: true, message: this.$t('messages.gLogin.linkEmpErr'), trigger: ['blur', 'change'] },
            { type: 'url', message: this.$t('messages.gLogin.urlErr'), trigger: ['blur', 'change'] },
            {
              validator: (rule, value, callback) => {
                let newUrl = this.getNewUrl(value)
                let params = {
                  country:'ID',
                  pre_info:newUrl,
                }
                this.$http
                  .get('/api/applications/gpinfo/', {params})
                  .then(() => {
                    callback()
                  })
                  .catch((error) => {
                    if(error.c===-1){
                      callback(this.$t('messages.gLogin.linkErr'))
                    }else{
                      callback(this.$t('messages.gLogin.nofind'))
                    }
                  })
              },
              trigger: 'blur',
            },
          ],
        }
      },
      changeContactType(value) {
        let path = this.applications.find(item => item.value === value).src
        this.$refs.contact_type.$el.children[0].setAttribute(
          'style',
          `background: url(${path}) no-repeat; background-size: 16px;background-position: 9px 16px;`
        )
      },
      Login(type){
        let params = {
          ...this.login,
          token:this.token,
          register_source:this.register_source,
        }
        if(type==='jump'){
          params.contact_number = ''
          params.product_url = ''
          params.contact_type = 0
          this.postLogin(params)
        }else{
          this.$refs.loginForm.validate(valid => {
            if (valid) {
              this.postLogin(params,this.login.product_url)
            }
          })
        }
      },
      postLogin(params,jumpUrl){
        let url = '/api/accounts/add-info/'
        this.loading = true
        this.$http
        .post(url, params)
        .then(() => {
          this.loading = false
          if(jumpUrl){
            this.routerChange('snapshot',{product_url:jumpUrl})
          }else{
            this.routerChange('snapshot')
          }
        })
        .catch(error => {
          this.loading = false
          this.notifyOpen('Error', error.m ||this.$t('messages.tipError.netErr'), 'error')
        })
      },
      // changeLang(){
      //   let str = this.$i18n.locale;
      //   if(str==='zh'){
      //     this.$i18n.locale = 'en'
      //   }else{
      //     this.$i18n.locale = 'zh'
      //   }
      // },
      getUrlParam(name,url) {
        var arr = url.split('?');
        var argStr = arr.length >1 ? arr[1]:'';
        if(!argStr){
            return null;
        }
        var arr2 = argStr.split('&').map(item=>item.split('='));
        var res = arr2.find(item=>item[0] === name);
        if(res){
            return res.length > 1 ? res[1] :null;
        }else{
            return null;
        }   
      },
      getNewUrl(value){
        let country = 'ID'
        let str=''
        if(this.getUrlParam('gl',value)&&this.getUrlParam('hl',value)){
          return value
        }
        if(country==='ID'){
          str = '&gl=id&hl=id'
        }
        if(country==='IN'){
          str = '&gl=in&hl=en'
        }
        if(country==='PH'){
          str = '&gl=ph&hl=en'
        }
        return value + str
      },
      changeAppStoreUrl(value) {
        this.$refs.loginForm.validateField('product_url', error => {
          if (!error) {
            let newUrl = this.getNewUrl(value)
            let params = {
              country:'ID',
              pre_info:newUrl,
            }
            this.$http
              .get('/api/applications/gpinfo/', {params})
              .then(() => {})
              .catch(() => {})
          }
        })
      },
    },
  }
</script>

<style lang="scss">
  .google-login-page{
    height: 100vh;
    background: url(../../assets/img/glogin-bg.png) no-repeat center center;
    background-size: cover;
    .contact-tip-wrap{
      display: flex;
      margin-top: -6px;
      margin-bottom: 18px;
      height: 28px;
      .tip-wrap-logo{
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
      >p{
        color: #bdc9c8;
        font-size: 12px;
      }
    }
    .google-header{
      padding: 35px 111px 0 102px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo-img{
        width: 183px;
        height: 32px;
      }
    }
    .google-content{
      width: 464px;
      margin: 0 auto;
      margin-top: 100px;
      .login-title{
        height: 48px;
        font-size: 36px;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 48px;
        margin-bottom: 40px;
        text-align: center;
      }
      .form-label{
        height: 24px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 24px;
        margin-bottom: 8px;
        display: inline-block;
      }
      .login-btn{
        width: 464px;
        height: 48px;
        background: #E30077;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 400;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 16px;
        cursor: pointer;
      }
      .login-input {
        .el-input__inner {
          font-size: 16px;
          height: 48px;
          line-height: 48px;
        }
        .el-input-group__append {
          padding: 0;
        }
        .el-input__suffix{
          background: #fff;
        }
      }
      .application-number {
        .el-select {
          .el-input {
            background: url('../../assets/img/Teams.png') no-repeat;
            background-size: 16px;
            background-position: 9px 16px;
          }
          .el-input__inner {
            text-indent: 20px;
            border-color: transparent !important;
          }
          .el-input__icon.el-input__validateIcon {
            display: none;
            color: transparent !important;
          }
          .el-input__suffix{
            right: -39px;
          }
        }
        .login-input2 {
          .el-input__inner {
            font-size: 16px;
            height: 48px;
            line-height: 48px;
            // width: 391px;
            &:first-child{
              // background: #E30077;
              width: 144px;
            }
            &:last-child{
              width: 320px;
            }
          }
          .el-input-group__append {
            padding: 0;
          }
          .el-input__suffix{
            background: #fff;
          }
        }
        .el-form-item__content{
          display: flex;
          flex-direction: column;
        }
      }
      .jump-tip{
        font-size: 14px;
        font-weight: 400;
        color: #C0C4CC;
        text-align: center;
        padding-top: 8px;
        display: none;
        >span:hover{
          cursor: pointer;
          color: #FFFFFF;
        }
      }
    }
    .guide-contact{
      padding: 16px 16px;
      width: 195px;
      background: #FFFFFF;
      box-shadow: 0px 4px 8px 0px rgba(33,35,41,0.08);
      border-radius: 4px;
      position: fixed;
      bottom: 103px;
      right: 35px;
      >div{
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        >img{
          width: 30px;
          height: 30px;
          margin-right: 8px;
        }
        >p{
          height: 24px;
          font-size: 16px;
          font-weight: 600;
          color: #303133;
          line-height: 24px;
        }
      }
      >p{
        font-size: 14px;
        font-weight: 400;
        color: #606266;
        line-height: 22px;
      }
    }
  }
  .langBtn{
    width: 82px;
    height: 32px;
    background: #E30077;
    border-radius: 4px ;
    font-size: 14px;
    font-weight: 700;
    color: #FFFFFF;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  @media screen and (max-width: 901px) {
    .google-login-page{
      padding: 0.4267rem !important;
      .google-header{
        padding: 0;
        .logo-img{
          width: 160px;
          height: 28px;
        }
      }
      .google-content{
        width: 100%;
        margin-top: 35px;
        .login-title{
          font-size: 26px;
          margin-bottom: 24px;
        }
        .form-label{
          font-size: 14px;
          height: 20px;
          line-height: 20px;
        }
        .application-number{
          .login-input2{
            .el-input__inner{
              &:last-child{
                width: 100% !important;
              }
            }
          } 
        } 
        .login-btn{
          width: 100%;
        }
      }
      .guide-contact{
        bottom: 35px;
        right: 65px;
      }
    }
  }
</style>
